import { useQueryClient } from '@tanstack/react-query';
import { useMutation } from 'query';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependency
import {
  getBookmarksFeedInfiniteQueryKey,
  getContentObjectDetailQueryKey,
  getFeedKey,
} from 'features/feed/queries/keys';
import { markActivityAsCompleted } from '../../services';

export const useMarkAsCompletedMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, { activityId: string }>({
    async mutationFn({ activityId }) {
      const response = await markActivityAsCompleted({ routeParams: { id: activityId } });

      return response.data;
    },
    onSuccess(_data, { activityId }) {
      void queryClient.invalidateQueries({ queryKey: getContentObjectDetailQueryKey({ id: activityId }) });
      void queryClient.invalidateQueries({ queryKey: getFeedKey() });
      void queryClient.invalidateQueries({ queryKey: getBookmarksFeedInfiniteQueryKey({}) });
    },
  });
};
